import { DEV, untrack } from "solid-js"
import { parse } from "valibot"
import { createSharedEntityXYGridMapMemo } from "../../../rx/memo/createSharedEntityXYGridMapMemo"
import type { Engine } from "../../core/engine/Engine.type"
import { DegreeNumberSchema } from "../../core/entity/EntityHeading/DegreeNumber.type"
import getEntityRenderHeight from "../../core/entity/getEntityRenderHeight"
import toCoord from "../../core/tile_position_xy/toCoord"
import setObjPosition from "../fn/setObjPosition"
import addEntityThreeModelUnitSprite from "./addEntityThreeModelUnitSprite"
import type { EntityThreeModel } from "./EntityThreeModel.type"
import getEntityExtraRenderHeight from "./getEntityExtraRenderHeight"

export default function updateEntityThreeModel(
  entityThreeModel: EntityThreeModel,
  entNode: EntityThreeModel['node'],
  engine: Engine,
): void {
  // console.log('updateEntityThreeModel', entityThreeModel.obj?.name)
  // if (entityThreeModel.obj?.name === 'Medium Tank_1') {
  //   console.error(new Error('updateEntityThreeModel '+entityThreeModel.obj?.name))
  // }
  const {
    obj,
    // ent: oldEnt
  } = entityThreeModel
  const ent = entityThreeModel.ent = untrack(entNode.raw)
  // console.log('[updateEntityThreeModel]', entityDisplayName(ent), deepClone(ent), obj)
  if (obj) {
    // console.log('oldEnt.player_id', oldEnt.player_id, 'ent.player_id', ent.player_id)
    obj.userData.id = entNode.id
    obj.userData.e = entNode
    // if (isEntityLightRecon(ent)) {
    //   console.log('[updateEntityThreeModel] obj.userData.targetHeading =', {
    //     newEntHeading: ent.heading,
    //     oldEntHeading: oldEnt.heading,
    //   }, obj, deepClone({ent, oldEnt}))
    // }
    if (DEV) {
      parse(DegreeNumberSchema, ent.heading)
    }
    
    obj.userData.targetHeading = ent.heading
    // console.log('[EntityGroup].update', entityDisplayName(ent), ent.id, deepClone(ent))
    const getEntityListAtXYMap = createSharedEntityXYGridMapMemo(engine)

    const rh = getEntityRenderHeight(getEntityListAtXYMap().get(toCoord(ent)) || [], ent)
      + getEntityExtraRenderHeight(ent)

    setObjPosition(obj, ent, rh)
    // obj.position.set(x, rh, z)
    // console.log('newGroup.position.set', JSON.stringify(obj.position).replaceAll(/"/g, ''), entityDisplayName(ent), ent.id)

    // const player = findById(engine.state.players, ent.player_id)
    // const pto = createPlayerThreeObject(player)
    // applyPlayerColors(obj, ent, pto)
    addEntityThreeModelUnitSprite(engine, entityThreeModel)
    // addEntityThreeModelVerticalHealthBarSprite(obj, ent)
    // addEntityThreeModelCargoIconSprite(obj, ent)

    let newVisible : boolean = true
    if (ent.taxi_id) {
      newVisible = false
    }
    obj.visible = newVisible
  }
}
